import { render, staticRenderFns } from "./ReportCards.vue?vue&type=template&id=c4869fb6"
import script from "./ReportCards.vue?vue&type=script&lang=js"
export * from "./ReportCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports